import { Icon, PATH } from '../icons'
import { fetchConversations, useAsync } from '../lib/api'

// 左側軌：品牌、新對話、歷史清單。#1364 起不再有後台／檢視器入口。
// 村里隔離由伺服器保證（cvt 決定 villageId），這裡刻意不送任何村里參數。

const HISTORY_LIMIT = 50

// 舊對話在標題回填之前寫入，title 是 null。給它一個看得懂的後備，
// 而不是讓側欄出現一排空白列。
const FALLBACK_TITLE = '未命名對話'

interface SidebarProps {
  activeConversationId: string | null
  // 每次對話有異動就 +1，用來重新拉清單
  version: number
  onNewChat: () => void
  onNavigate: () => void
}

export function Sidebar(props: SidebarProps) {
  const { data, error, loading } = useAsync(
    () => fetchConversations(HISTORY_LIMIT), [props.version],
  )

  // 伺服器已依 lastActiveAt 由新到舊，這裡再排一次讓順序不依賴呼叫端以外的東西
  const rows = [...(data?.conversations ?? [])].sort(
    (a, b) => Date.parse(b.lastActiveAt) - Date.parse(a.lastActiveAt),
  )

  return (
    <nav className="side">
      <div className="side-brand">
        {/* 品牌圖像尚未提供：先用文字標籤撐住，不放假 logo 也不留一塊空洞 */}
        <span className="side-brand-name">AI-林好特助</span>
        <span className="side-brand-sub">AI 疑難雜事，找林好！</span>
      </div>

      <button className="side-new" onClick={props.onNewChat}>
        <Icon d={PATH.plus} size={18} />新對話
      </button>

      <div className="side-list">
        <p className="side-caption">對話紀錄</p>
        {loading && <p className="side-empty">載入中…</p>}
        {error && <p className="side-empty">歷史載入失敗</p>}
        {!loading && !error && rows.length === 0 && (
          <p className="side-empty">還沒有對話。問一個問題就開始了。</p>
        )}
        {rows.map((c) => (
          <a
            key={c.conversationId}
            className={`side-item ${c.conversationId === props.activeConversationId ? 'on' : ''}`}
            href={`#/c/${encodeURIComponent(c.conversationId)}`}
            onClick={props.onNavigate}
            title={c.title ?? FALLBACK_TITLE}
          >
            <Icon d={PATH.chat} size={16} />
            <span>{c.title || FALLBACK_TITLE}</span>
          </a>
        ))}
      </div>
    </nav>
  )
}
